import getDefaultMenu from '../../components/Post/menu'

function getMenu(props = {}) {
    return getDefaultMenu(props).map(() => {
        return null
    }).filter((menu) => menu)
}

export default getMenu
